var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container summary",
      class: { mobile: _vm.isMobile(_vm.$mq) }
    },
    [_vm._m(0), _vm._v(" "), _vm._m(1)]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("h3", [
        _vm._v("\n      Learn key ideas through\n      "),
        _c("strong", [_vm._v("problem solving")])
      ]),
      _vm._v(" "),
      _c("div", [
        _c("img", {
          attrs: {
            src:
              "/site_media/version-f234aa6a49/images/homepage/problem-solving-2x.gif",
            alt: "Problem solving"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "unstyled" }, [
      _c("li", [
        _c("h4", [_vm._v("For ages 10 to 110")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        Get started as a beginner with the fundamentals, or dive right into intermediate and\n        advanced courses for professionals. Brilliant has courses for ambitious people of all\n        ages.\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("h4", [_vm._v("Master essential skills")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        Build confidence with hands-on learning. You'll get to see concepts visually, interact\n        with key ideas, and solve challenging problems that get you to really think.\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("h4", [_vm._v("Stress less, learn better")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        Enjoy fun storytelling, guided problem solving, and making lots of mistakes while playing.\n        On Brilliant, your natural curiosity will drive you, not the threat of a test.\n      "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }